import BaseTable from 'components/Tables/BaseTable';
import { actions as scenariosDescriptorsConditionsActions } from 'ducks/scenariosDescriptorsConditions';
import { sortBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getImmutableStoreData, lookUpIdValueSelector } from 'selectors/generic';
import arrayToObject from 'utils/arrayToObject';
import columns from 'utils/tables/columns/scenarioConditions';

const Component = props => {
  const {
    conditionsFilter, conditionsById, descriptors, scenarioDescriptor,
    units, user
  } = props;
  const { conditions, scenarioDescriptorConditions } = props;
  const { closeConditions, create, remove, update } = props;
  const tableRef = React.useRef(null);

  const filteredConditions = conditions.filter(v => v.tipo === conditionsFilter);

  const filteredSDC = scenarioDescriptorConditions.filter(sdc =>
    sdc.id_cenariodescritor === scenarioDescriptor.id
  );

  const [selectedIds, setSelectedIds] = useState(filteredSDC.map(fsdc => fsdc.id_condicao));
  const [loading, setLoading] = useState(false);

  useEffect(
    () => setSelectedIds(filteredSDC.map(fsdc => fsdc.id_condicao)),
    [scenarioDescriptorConditions]
  );

  // TODO Adding Checked info to table, there should be a better way
  const fsdcByConditionId = arrayToObject(filteredSDC, 'id_condicao');
  const rows = filteredConditions.map(element => {
    const baseElement = { ...element, valor: '' }
    // TODO fsdcByConditionId[element.id] condition has this because the state suffers
    // TODO update on useEffect and not with action, should be corrected
    if (selectedIds.includes(element.id) && fsdcByConditionId[element.id]) {
      const valor = fsdcByConditionId[element.id].valor;
      const id_unidade = fsdcByConditionId[element.id].id_unidade;
      return {
        ...baseElement,
        tableData: { checked: true },
        valor,
        id_unidade
      };
    } else if (element.tableData && element.tableData.checked) {
      return { ...baseElement, tableData: { checked: false } }
    } else {
      return baseElement
    }
  });

  const reOrderedRows = sortBy(rows, [o => !selectedIds.includes(o.id)]);

  return (
    <React.Fragment>
      <BaseTable
        ref={tableRef}
        titleBack={true}
        titleAction={closeConditions}
        title={`CONDIÇÕES - ${descriptors[scenarioDescriptor.id_descritor].codigo}`}
        columns={columns(user, units)}
        data={reOrderedRows}
        onRowClick={() => null}
        paging={false}
        options={{
          selection: true,
          showTextRowsSelected: false,
          showSelectAllCheckbox: false,
          selectionProps: rowData => ({
            //checked: prevInterSubstanceIds.includes(rowData.id)
            //onClick: (event , rowData) => this.handleCheckboxClick(event,rowData),
          })
        }}
        isLoading={loading}
        editable={{
          onRowUpdate: (newData, oldData) => {
            if (oldData.tableData.checked) {
              const id_sdc = filteredSDC.find(fsdc => fsdc.id_condicao === newData.id).id;
              return update(
                id_sdc,
                {
                  ...newData,
                  id_unidade: newData.id_unidade === '' ? null : newData.id_unidade
                }
              );
            } else {
              return create({
                id_cenariodescritor: scenarioDescriptor.id,
                id_condicao: newData.id,
                ...newData,
                id_unidade: newData.id_unidade === '' ? null : newData.id_unidade
              })
            }
          }
        }}
        onSelectionChange={(rows, difRow) => {
          setLoading(true);
          if (rows.length > selectedIds.length) {
            create({
              id_cenariodescritor: scenarioDescriptor.id,
              id_condicao: difRow.id,
              id_unidade: conditionsById[difRow.id].id_unidade
            })
              .then(() => setLoading(false))
              .catch(e => alert(e));
          } else {
            const id_sdc = filteredSDC.find(fsdc => fsdc.id_condicao === difRow.id).id;
            remove(id_sdc)
              .then(() => setLoading(false))
              .catch(e => alert(e));
          }
        }}
      />
    </React.Fragment>
  )
};

const makemapStateToProps = () => {
  const conditions = getImmutableStoreData('conditions');
  const units = lookUpIdValueSelector('units', ['nome']);
  const mapStateToProps = (state, props) => ({
    conditions: conditions(state),
    conditionsById: state.conditions.dataById,
    descriptors: state.descriptors.dataById,
    scenarioDescriptorConditions: state.scenarioDescriptorConditions.data,
    units: units(state),
    user: state.profile.entity,
  })
  return mapStateToProps
};

const mapDispatchToProps = dispatch => ({
  create: data => dispatch(scenariosDescriptorsConditionsActions.createPromise(data)),
  update: (id, data) => dispatch(scenariosDescriptorsConditionsActions.updatePromise(id, data)),
  remove: id => dispatch(scenariosDescriptorsConditionsActions.removePromise(id))
});

export default connect(makemapStateToProps, mapDispatchToProps)(Component);
